export default __webpack_public_path__ + "_/images/tipsgg/logo-ea2dc8f2d72dcd05503be93829e9d800bf9ac596df38e1bdd60f15369c380ca4.png";